// extracted by mini-css-extract-plugin
export default {"tooltip":"pp-z","sharingV2":"qp-z","sharingIconsV2":"rp-z","links":"sp-z","link":"tp-z","facebookV2":"up-z","twitterV2":"vp-z","pinterestV2":"wp-z"};